import styled from '@emotion/styled'

import { ORGANIZATION_LOGO_AND_ICON_SECTIONS_HEIGHT } from '../../constants/organizationLogoAndIconSectionsHeight'

export const IconWrapper = styled.div`
  height: ${ORGANIZATION_LOGO_AND_ICON_SECTIONS_HEIGHT}px;
`
